function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 0,
  width: 131,
  height: 2
});

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 15,
  width: 131,
  height: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 0,
  y: 30,
  width: 131,
  height: 2
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 131 32"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/menu.be75b26a.svg";
export { SvgComponent as ReactComponent };